<div class="page-title-section row m-0 pt-5 pb-4 flex-column">
  <div class="main-title main-theme-color d-flex text-uppercase justify-content-center text-center text-uppercase">
    {{!activityService.isDining ? (activityService.isNonDining ? activityService.selectedNonDining.RestaurantName : selectedActivity?.Name) : activityService.selectedDining.RestaurantName}}
  </div>
  <div class="main-title main-theme-color d-flex justify-content-center text-center text-uppercase">{{'guestDetails' |
  translate}}</div>
  <div class="sub-title secondary-theme-color d-flex justify-content-center text-center text-uppercase">
    {{'reservationSubTitle' | translate}}
  </div>
</div>
<!-- AddOn Selection Container -->


<div class="container activity-data mt-3">
  <!-- <mat-expansion-panel hideToggle class="mb-3 activity-accordian-panel" 
   ="selectedActivity">

  <mat-expansion-panel-header class="activity-panel-header">
    <div class="w-100 order-summary-short-detail-section p-3 mx-2 d-flex flex-row justify-content-between" [ngStyle]="{'background-color': this.selectedActivity.isAvailable ? 'rgba(255,0,0,0.1)' : ''}">
      <div
        class="guest-count activity-description-bold d-flex flex-wrap justify-content-center align-items-center text-center">
        <mat-icon>card_travel</mat-icon>
        <div class="px-2 order-details-activity-name text-wrap text-center">{{this.selectedActivity.LessonName}}</div>
      </div>
      <div class="order-summary-spacer mx-2"></div>
      <div
        class="guest-count activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
        <mat-icon>person</mat-icon>
        <div class="px-2 text-center">{{this.activityService.selectedSize}}</div>
      </div>
      <div class="order-summary-spacer mx-2"></div>
      <div
        class="activity-selected-date activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
        <mat-icon>calendar_today</mat-icon>
        <div class="px-2 text-center">
          <ng-container>{{this.activityService.selectedSlot.Start | date: 'dd MMM
          yyyy'}}</ng-container>
        </div>
      </div>
      <div class="order-summary-spacer mx-2"></div>
      <div
        class="activity-selected-time activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
        <mat-icon>access_time</mat-icon>
        <div class="px-2 d-flex align-items-center justify-content-center">
          <span class="text-center">
            <ng-container>{{this.activityService.selectedSlot.Start | date: 'hh:mm
            a'}}</ng-container>
          </span>
        </div>
      </div>
    </div>
  </mat-expansion-panel-header>
</mat-expansion-panel> -->
<div class="row activity-lite">
  <!-- <div class="col-lg-2 col-md-2 col-xl-2"></div> -->
  <div class="col-lg-12 col-md-12 col-xl-12 col-xs-12 addon place-content-center"  >
    <div class="row">
      @if ((mandatoryAddOns?.length > 0 || additionalAddOns?.length > 0) && allEligibleAddOns?.length) {
        <mat-card class="col-lg-6 col-md-12 col-xl-6 col-sm-12 col-xs-12 float-left" [ngStyle]="{'max-height': !expand ? '70px' : '600px'}"
          [class.collapseMode]="!expand" style="
       transition: 0.5s;
        padding: 0;
        border: 1px solid #ededed;
        margin-bottom: 18px;
        padding-bottom: 15px;
        position: relative;
        overflow: auto;
        ">
          <div class="addon__header">
            <span>{{'addons' | translate}}
              @if (mandatoryCategoryAddons?.length) {
                <span style="font-weight: bold;color: red;font-size: 20px;"> *</span>
              }
            </span>
            @if (screenWidth < 992) {
              <span class="arrow-view icon-Right-Arrow" (click)="expandAddOn()"></span>
            }
            @if (mandatoryCategoryAddons?.length && (screenWidth >= 992 || expand)) {
              <div class="addon__mandatory-info">
                @for (name of mandatoryCategoryAddons; track name) {
                  <div>
                    {{ 'minCategoryAddonMessage' | translate: {name: name} }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="addon__panel-view">
            <div class="addon__panel-body">
              @for (item of allEligibleAddOns; track item) {
                <div class="addon__addon-section"
                  [ngStyle]="{'border-bottom-color':item | getCategoryData :  restaurantData.PreferencesCategories  :'Color' }">
                  @if (item.IsVisible) {
                    <div class="addon__card-details">
                      <div class="addon__card-view">
                        <div class="addon__addon-details">
                          <div class="addon__name">
                            <span class="addon_name_formatted" [title]="item.AddonName">
                            {{item.AddonName}}</span>
                            @if (item.IsMandatory) {
                              <span style="font-weight: bold;color: red;font-size: 20px;"> *</span>
                            }
                          </div>
                          <span class="seat-labels"
                            [ngStyle]="{'color':item | getCategoryData :  restaurantData.PreferencesCategories  :'Color' }">
                          {{item | getCategoryData : restaurantData.PreferencesCategories  :'Text'}}</span>
                        </div>
                        <div class="addon__addon-price">
                          <div style="text-align:right">{{restaurantData.OperationCurrency}} {{item.Price | currencyDecimalFormatter}}
                          </div>
                          @if (item.PricingCategory == PricingCategory.ByDuration) {
                            <div>
                              @if (item.PricingType == PricingType.ByHour) {
                                <span class="seat-body-text">
                                For {{ item.AddOnDetails[0].Duration }} {{'hours' | translate}}</span>
                              }
                              @if (item.PricingType == PricingType.ByMinutes) {
                                <span class="seat-body-text">
                                For {{ item.AddOnDetails[0].Duration }} {{'minutes' | translate}}</span>
                              }
                            </div>
                          }
                          @if (item.PricingCategory == PricingCategory.BySession) {
                            <div class="seat-body-text">{{'perSession' |
                            translate}}</div>
                          }
                        </div>
                      </div>
                      <div class="addon__card-quantity seat-header-four">
                        <div class="addon__availablility">
                          <label for="" class="addon__available-text">{{"available" | translate}}</label>
                          @if (!item.IsUnlimited) {
                            <label class="seat-grid-content" for="">
                              <span
                              [ngClass]="{'addon__available': item.AvailableQuantity, 'addon__soldout' : !item.AvailableQuantity }">{{item.AvailableQuantity}}</span>
                            of {{item.OverAllQuantity}}</label>
                          }
                          @if (item.IsUnlimited) {
                            <label class="addon__unlimited">
                              {{'Unlimited' | translate}}
                            </label>
                          }
                        </div>
                        <div class="addon__quantity-selection">
                          <div class="addon__icon-area">
                            <span class="icon-minus-outline" (click)="decreaseAddOn(item)"></span>
                            <mat-form-field appearance="outline" class="addon-count">
                              <input [(ngModel)]="item.selectedQuantity" type="number" (keypress)="isNumberKey($event)" (ngModelChange)="validateAddOnsQtyOnChange(item)"
                                (focusout)="addonQuantityValidations($event, item)" matInput>
                              </mat-form-field>
                              <span class="icon-add1" (click)="increaseAddOn(item)"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
              <!-- <div @if (notes.commentsBox?.id && !activityService.isDining) { class="pt-2" style="font-size: 13px;color: #585252">
            {{'note' | translate}}: {{'specificPartyJoining' | translate}}</div>
            <div @if (notes.commentsBox?.id) { class="pt-3 d-flex flex-row">
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>{{'leaveaComment' | translate}}</mat-label>
                <textarea [(ngModel)]="notes.commentsBox.value" matInput placeholder="{{'addCommentsHere' | translate}}"></textarea>
              </mat-form-field>
            </div> } -->
          </div>
        </mat-card>
      }


        <mat-card class="guest-details-block float-left"  [ngClass]="[(mandatoryAddOns?.length > 0 || additionalAddOns?.length > 0) && allEligibleAddOns?.length ? 'col-lg-6 col-md-12 col-xl-6 col-xs-12 col-sm-12' 
          : 'm-auto col-lg-8 col-md-8 col-xl-8 col-sm-8 col-xs-8']">
        <div class="addon__header w-100">
          <span>{{'guestDetails' | translate}}</span>
          @if (stayGuestList?.length > 0 && this.activityService.operation != 0) {
            <div> <!--Show this drop down on create alone-->
              <mat-form-field class="px-2 col-sm-6 col-12" id="full-width" class="seating-fields" appearance="outline">
                <mat-label>{{'selectGuest' | translate}}</mat-label>
                <mat-select [(ngModel)]="SelectedGuestToFillIn" name="stayGuest"
                  placeholder="{{'selectSeatingArea' | translate}}"
                  (ngModelChange)="SelectedGuestToFillInChangeHandler()">
                  <mat-option [value]="Guest" *ngFor="let Guest of stayGuestList;">{{Guest.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
        <div class="guest-section" [ngClass]="{'alias-name' : !activityService?.widgetSettings?.ShowAliasName}">
          <dynamic-form [config]="guestConfig" #form="dynamicForm">
          </dynamic-form>
        </div>
        <div class="notes-section">
          <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
        </div>
        @if (this.activityService.selectedDining.MarketingFlagEnabled) {
          <div class="marketingFlag-section">
            <dynamic-form [config]="marketingFlag" #form="dynamicForm">
            </dynamic-form>
          </div>
        }
        @if (allowAddingSecondaryGuest && secondaryGuestDetails && secondaryGuestDetails.length > 0) {
          <div
            class="guest-section__secondary-guest pt-4">
            @for (secondaryGuest of secondaryGuestDetails; track secondaryGuest; let i = $index) {
              <div class="guest-section__secondary-guest-details pb-4"
                [hidden]="this.editContactData?.Id && secondaryGuest?.ContactId == this.editContactData?.Id ">
                <app-activities-lite-secondary-guest-data [restaurantDetail]="restaurantData"  [secondaryGuestCount]="i+1" [secondaryGuestVisibileFields]="secondaryGuestVisibileFields"
              [selectedActivity]="selectedActivity" [secondaryGuestDetail]="secondaryGuest" (deleteSecondaryGuest)="deleteSecondaryGuest($event)" [customGuestFields]="customGuestFields" [stayGuestList]="stayGuestList" [noteType]="noteType" (secondaryGuestNotes)="secondaryGuestNotes($event)" (secondaryGuestData)="secondaryGuestValid($event)" [isNewGuest]="!secondaryGuest.Id && this.activityService.operation === 0"></app-activities-lite-secondary-guest-data>

              </div>
            }
          </div>
        }
        @if (allowAddingSecondaryGuest && additionalSecondaryGuestCount) {
          <button mat-button type="button"
            class="my-3 activity-buttons activity-confirm-buttons add-guest-btn-decoration text-center text-uppercase"
            (click)="addSecondaryGuestDetails();">
            {{'addAdditionalGuest' | translate}}
          </button>
        }
      </mat-card>
    </div>

  </div>
  <!-- <div class="col-lg-2 col-md-2 col-xl-2">

</div> -->
</div>

@if (cancellationDescription && cancellationDescription!= '') {
  <div class="col-12 container cancellation-policy" >
    <mat-card [ngClass]="{'col-lg-12 col-md-12 col-xl-12 col-sm-12 col-xs-12 m-auto': (mandatoryAddOns?.length > 0 || additionalAddOns?.length > 0)}"
      [ngClass]="{'col-lg-8 col-md-12 col-xl-8 col-sm-12 col-xs-12 m-auto': !(mandatoryAddOns?.length > 0 || additionalAddOns?.length > 0)}">
      <h3 class="cancellation-policy__policy-header">
        {{'CancellationPolicy' | translate}}
      </h3>
      <div class="cancellation-policy__content">
        {{cancellationDescription}}
      </div>
    </mat-card>
  </div>
}
</div>

<ng-template #notesDisplayContent>
  @for (notes of notesOptions; track notes) {
    <!-- Enable when Notes is added for Activities -->
    @if (notes.text) {
      <div class="activity-description-bolder text-uppercase">
        {{notes.text}}
      </div>
    }
    <div class="d-flex flex-row">
      <mat-chip-listbox multiple>
        @for (option of notes.checkBoxOptions; track option) {
          <mat-chip-option class="cursor allergy-chip" [selected]="option.selected"
            [value]="option.value" (click)="toggleSelection(option)">
           <!--  @if (option.selected) {
              <mat-icon class="chip-check-icon">check</mat-icon>
            } -->
            <span class="allergy-chip__text" [matTooltip]="option.value" matTooltipPosition="above">{{option.value}}</span>
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </div>
    <!-- <div @if (notes.commentsBox?.id && !activityService.isDining) { class="pt-2" style="font-size: 13px;color: #585252">
  Note: Please specify the party that you are joining</div> } -->
  @if (notes.commentsBox?.id) {
    <div class="pt-3 d-flex flex-row">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>{{'leaveaComment' | translate}}</mat-label>
        <textarea [(ngModel)]="notes.commentsBox.value" matInput placeholder="{{'addCommentsHere' | translate}}"></textarea>
      </mat-form-field>
    </div>
  }
}
</ng-template>
